import { makeStyles } from '@mui/styles';
import { red } from '@mui/material/colors';

export const useErrorAutocompleteStyles = makeStyles(() => ({
  root: {
    '& label': {
      color: red[500],
    },
    '& label.Mui-focused': {
      color: red[500],
    },
    '& .MuiInput-underline:after': {
      borderColor: red[500],
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: red[500],
      },
      '&:hover fieldset': {
        borderColor: red[500],
      },
      '&.Mui-focused fieldset': {
        borderColor: red[500],
      },
    },
    '& .MuiIconButton-label': {
      color: red[500],
    },
  },
}));
